export const constants = {
  // Login actions
  LOGIN_REQUEST: "LOGIN_REQUEST",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGIN_FAILURE: "LOGIN_FAILURE",

  // Logout actions
  LOGOUT_REQUEST: "LOGOUT_REQUEST",
  LOGOUT_SUCCESS: "LOGOUT_SUCCESS",
  LOGOUT_FAILURE: "LOGOUT_FAILURE",

  // Practice actions
  PRACTICE_CREATE_REQUEST: "PRACTICE_CREATE_REQUEST",
  PRACTICE_CREATE_SUCCESS: "PRACTICE_CREATE_SUCCESS",
  PRACTICE_CREATE_FAILURE: "PRACTICE_CREATE_FAILURE",

  PRACTICE_UPDATE_REQUEST: "PRACTICE_UPDATE_REQUEST",
  PRACTICE_UPDATE_SUCCESS: "PRACTICE_UPDATE_SUCCESS",
  PRACTICE_UPDATE_FAILURE: "PRACTICE_UPDATE_FAILURE",

  PRACTICE_GET_REQUEST: "PRACTICE_GET_REQUEST",
  PRACTICE_GET_SUCCESS: "PRACTICE_GET_SUCCESS",
  PRACTICE_GET_FAILURE: "PRACTICE_GET_FAILURE",
};
